import { fromLatLon } from 'utm';
import { forward as toMgrs } from 'mgrs';

export function formatWgs84(lat, lng) {
  return `${lat.toFixed(4)}  ${lng.toFixed(4)}`;
}

export function formatDms(lat, lng) {
  return `${toDms(lat, true)}  ${toDms(lng, false)}`;
}

export function formatDdm(lat, lng) {
  return `${toDdm(lat, true)}  ${toDdm(lng, false)}`;
}

export function formatUtm(lat, lng) {
  try {
    const { easting, northing, zoneNum, zoneLetter } = fromLatLon(lat, lng);
    return `${zoneNum}${zoneLetter} ${Math.round(easting)} ${Math.round(
      northing
    )}`;
  } catch {
    return 'N/A (polar)';
  }
}

export function formatMgrs(lat, lng) {
  try {
    return toMgrs([lng, lat]);
  } catch {
    return 'N/A (polar)';
  }
}

export function allFormats(lat, lng) {
  return [
    { key: 'wgs84', label: 'WGS84', value: formatWgs84(lat, lng) },
    { key: 'dms', label: 'DMS', value: formatDms(lat, lng) },
    { key: 'ddm', label: 'DDM', value: formatDdm(lat, lng) },
    { key: 'utm', label: 'UTM', value: formatUtm(lat, lng) },
    { key: 'mgrs', label: 'MGRS', value: formatMgrs(lat, lng) }
  ];
}

function toDms(deg, isLat) {
  const abs = Math.abs(deg);
  const d = Math.floor(abs);
  const minFloat = (abs - d) * 60;
  const m = Math.floor(minFloat);
  const s = Math.round((minFloat - m) * 60);
  const dir = isLat ? (deg >= 0 ? 'N' : 'S') : deg >= 0 ? 'E' : 'W';
  return `${d}\u00b0${String(m).padStart(2, '0')}'${String(s).padStart(
    2,
    '0'
  )}"${dir}`;
}

function toDdm(deg, isLat) {
  const abs = Math.abs(deg);
  const d = Math.floor(abs);
  const m = ((abs - d) * 60).toFixed(3);
  const dir = isLat ? (deg >= 0 ? 'N' : 'S') : deg >= 0 ? 'E' : 'W';
  return `${d}\u00b0${m}'${dir}`;
}
